"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const typesConstants_1 = require("../../constants/typesConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const authSlice_1 = require("./authSlice");
const button_1 = __importDefault(require("../../components/button/button"));
const utils_1 = require("../../utils/utils");
const FieldErrorMessageComponent_1 = __importDefault(require("../../components/FieldErrorMessageComponent/FieldErrorMessageComponent"));
const constants_1 = require("../../constants/constants");
const eventConstants_1 = require("../../constants/eventConstants");
const scheduleSlice_1 = require("../schedules/scheduleSlice");
const SignIn = () => {
    const dispatch = useAppDispatch_1.default();
    const { loadingStatus, errorMessage, errors, message } = useAppSelector_1.default((state) => ({
        loadingStatus: state.auth.status,
        errorMessage: state.auth.errorMessage,
        errors: state.auth.errors,
        message: state.auth.message,
    }));
    const [username, setUsername] = react_1.useState('');
    const [password, setPassword] = react_1.useState('');
    const performLogin = () => {
        const payload = {
            username,
            password,
        };
        dispatch(scheduleSlice_1.resetScheduleState());
        dispatch(authSlice_1.login(payload));
    };
    const isLoading = loadingStatus === typesConstants_1.PENDING_STATUS;
    const isError = loadingStatus === typesConstants_1.FAILED_STATUS;
    const isSucceded = loadingStatus === typesConstants_1.SUCCEEDED_STATUS;
    const hasMessage = !!message;
    const [loading, setLoading] = react_1.useState(react_1.default.createElement(react_native_1.View, null));
    const [errorState, setErrorState] = react_1.useState(react_1.default.createElement(react_native_1.View, null));
    const [messageView, setMessageView] = react_1.useState(react_1.default.createElement(react_native_1.View, null));
    react_1.useEffect(() => {
        if (isLoading) {
            setLoading(react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorBlack }, ` Checking data... `));
        }
        else if (isError) {
            setLoading(react_1.default.createElement(react_native_1.View, null));
        }
        else if (isSucceded) {
            setLoading(react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorBlack }, ` Welcome! `));
        }
        if (isError) {
            setErrorState(react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorRed }, utils_1.getError('non_field_errors', errors) || errorMessage));
        }
    }, [loadingStatus]);
    react_1.useEffect(() => {
        if (hasMessage)
            setMessageView(react_1.default.createElement(react_native_paper_1.Subheading, null, message));
    }, [hasMessage]);
    return (
    // this needs platform.OS cause this style only cares for the platform
    react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === constants_1.WEB_TAG ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChilds },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, react_native_1.Platform.OS === constants_1.WEB_TAG ? null : { paddingBottom: 50 }] },
                react_1.default.createElement(react_native_1.View, null,
                    loading,
                    errorState,
                    messageView),
                react_1.default.createElement(react_native_paper_1.TextInput, { label: "Your email", placeholder: "Your email", onChangeText: setUsername, left: true, keyboardType: "email-address", autoCorrect: false, autoCapitalize: "none", style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: username }),
                react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('username', errors) }),
                react_1.default.createElement(react_native_paper_1.TextInput, { label: "Password", placeholder: "Password", onChangeText: setPassword, left: true, autoCapitalize: "none", secureTextEntry: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: password }),
                react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('password', errors) }),
                react_1.default.createElement(button_1.default, { text: "LOGIN", onPress: performLogin, icon: free_solid_svg_icons_1.faCheckCircle, fill: true, eventName: eventConstants_1.LOGIN_PRESS })))));
};
exports.default = SignIn;
